import React from 'react'
import './styles.css'

interface NavigationProps {
  linkClicked: () => void
}

export const Navigation = ({ linkClicked }: NavigationProps) => {
  /* TEMPLATE onClick={linkClicked}>
        <a href='#/registration' className='nav-link' onClick={linkClicked}> 
          Online-Nennung
              </a>
  
  */
  return (
    <nav style={{ zIndex: 1000 }}>
      <div className='nav-container'>
        <a href='#/home' className='nav-link' onClick={linkClicked}>
          Startseite
        </a>
        <a href='#/registration' className='nav-link' onClick={linkClicked}>
            Online-Nennung
        </a>
        <a href='#/address-change' className='nav-link' onClick={linkClicked}>
          Adress&auml;nderung
        </a>

        <a href='mailto:service@pfae.org' className='nav-link'>
          Kontakt
        </a>

        <a href='https://www.pfae.org/online-nennung' target='_blank' className='nav-link'>
          Hilfe
        </a>
      </div>
      <div className='nav-footer'>&copy; 2025 JK &amp; JT.</div>
    </nav>
  )
}
